/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Fact_Floor_AreaInputs */

const cs_public_site_fact_floor_area = /** @type {(inputs: Public_Site_Fact_Floor_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zastavěná plocha`)
};

const en_public_site_fact_floor_area = /** @type {(inputs: Public_Site_Fact_Floor_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Built-up area`)
};

/**
* | output |
* | --- |
* | "Built-up area" |
*
* @param {Public_Site_Fact_Floor_AreaInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_fact_floor_area = /** @type {((inputs?: Public_Site_Fact_Floor_AreaInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Fact_Floor_AreaInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_fact_floor_area(inputs)
	return cs_public_site_fact_floor_area(inputs)
});